<template>
    <div class="edit-contact">
        <div class="edit-contact-inner">
            <div v-if="showPhone" class="edit-contact-item">
                <VCheckbox v-model="isEditPhone" style="margin-bottom: 12px;" :disabled="false"
                    @change="chooseEditPhoneOrQQ('phone')"
>
                    {{ $t('修改管理员手机') }}
                </VCheckbox>
                <div :class="{ 'edit-contact-item-box-for-opacity': !isEditPhone }">
                    <v-form kind="desc" size="small">
                        <v-form-item :label="$t('原管理员手机')" name="1">
                            {{ contact.mobile || '' }}
                        </v-form-item>
                        <v-form-item v-model="formError.phone" :label="$t('新管理员手机')" :required="$t('请输入手机号')" name="phone">
                            <v-input v-model="newPhone" :disabled="!isEditPhone" :value="newPhone" name="newPhone"
                                :maxlength="11" :placeholder="$t('请输入手机号')" max-length="11" style="width: 100%;"
                                @input="storagePhoneNum"
/>
                        </v-form-item>
                        <v-form-item v-model="formError.code" :label="$t('验证码')" :required="$t('请输入验证码')" name="code">
                            <v-input v-model="checkNumber" :width="265" :disabled="!isEditPhone" :value="checkNumber"
                                name="checkNumber" :maxlength="6" :placeholder="$t('请输入验证码')" @input="storagePhoneNum"
/>
                            <v-button :disabled="!isEditPhone || isGetingVCode || newPhone.length !== 11"
                                class="geryzm-button" status="default" @click="getYzm"
>
                                {{ VcodeText }}
                            </v-button>
                        </v-form-item>
                    </v-form>
                </div>
            </div>
            <div v-if="showQq" class="edit-contact-item">
                <VCheckbox v-model="isEditQQ" :disabled="false" style="margin-bottom: 12px;"
                    @change="chooseEditPhoneOrQQ('qq')"
>
                    {{ $t('修改管理员QQ') }}
                </VCheckbox>
                <div :class="{ 'edit-contact-item-box-for-opacity': !isEditQQ }">
                    <v-form kind="desc" size="small">
                        <v-form-item :label="$t('原管理员QQ')" name="2">
                            {{ contact.admin_qq || '' }}
                        </v-form-item>
                        <v-form-item :label="$t('新管理员QQ')" :required="$t('请添加管理员QQ')" name="qq">
                            <v-button icon="basic_new_line" remote v-if="myNewQQ == ''" :disabled="!isEditQQ" status="default" @click="addNewAdminQQ">
                                {{ $t('添加新管理员QQ') }}
                            </v-button>
                            <div v-else class="old-contact-item-number">
                                <v-popconfirm ref="deleteQQ" status="warning" @confirm="deleteNewAdminQQ"
                                    @visibleChange="handleVisibleChange"
>
                                    <div class="demo-popconfirm-first">
                                        <h3>{{ $t('确定要删除吗？') }}</h3>
                                    </div>
                                    <span slot="confirm-text">{{ $t('删除') }}</span>
                                </v-popconfirm>
                                <div class="old-contact-item-number-newQQ">
                                    {{ myNewQQ }}
                                </div>
                                <v-button v-popconfirm:deleteQQ type="link" kind="primary" icon="basic_delete_line"
                                    :disabled="!isEditQQ" remote
/>
                            </div>
                        </v-form-item>
                    </v-form>
                </div>
            </div>
        </div>
        <div class="edit-contact-bottom">
            <v-button status="primary" size="large" :disabled="!isCanNextStep" @click="nextStep">
                {{ $t('下一步') }}
            </v-button>
            <v-button status="default" size="large" style="margin-left: 20px;" @click="cancel">
                {{ $t('取消') }}
            </v-button>
        </div>
    </div>
</template>

<script>
const COUNT_DOWN_SECONDS = 60;
export default {
    props: {
        contact: {
            type: Object,
            default: () => { },
        },
        newQQ: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            newPhone: '', // 新手机号
            checkNumber: '', // 验证码
            showPhone: false,
            showQq: false,
            isEditPhone: false, // 是否要更改联系手机
            isEditQQ: false, // 是否要修改管理员QQ
            regForPhone: /^1[3456789]\d{9}$/,
            VcodeText: this.$t('获取验证码'), // 获取验证码按钮的文字
            isGetingVCode: false, // 是否在获取验证码倒计时中
            isPhoneTrue: true, // 判断电话号是否合法
            errorPhoneTips: this.$t('请输入正确的手机号'), // 输入手机号顶部的错误信息提示
            formError: {
                phone: '',
            },
        };
    },
    computed: {
        // 是否可以点击下一步了
        isCanNextStep() {
            return (this.isEditPhone && this.contact.mobile && this.isPhoneTrue && this.checkNumber && this.newPhone
                && this.isEditQQ && this.contact.admin_qq)
                || (this.isEditPhone && this.contact.mobile && this.isPhoneTrue && this.checkNumber && this.newPhone && !this.isEditQQ)
                || (this.isEditQQ && this.contact.admin_qq && !this.isEditPhone);
        },
        // 用计算属性来监听获取到父组件传过来的新QQ号
        myNewQQ() {
            return this.newQQ;
        },
    },
    watch: {
        contact: {
            handler() {
                if (this.contact && this.contact.defaultSelect && this.contact.defaultSelect.length > 0) {
                    if (this.contact.defaultSelect.includes(0)) this.isEditPhone = true;
                    if (this.contact.defaultSelect.includes(1)) this.isEditQQ = true;
                }
            },
            deep: true,
        },
    },
    mounted() {
        if (this.contact.admin_qq) this.showQq = true;
        if (this.contact.mobile) this.showPhone = true;
        // 判断当前是选择修改手机号还是修改QQ号
        if (this.contact && this.contact.defaultSelect && this.contact.defaultSelect.length > 0) {
            if (this.contact.defaultSelect.includes(0)) this.isEditPhone = true;
            if (this.contact.defaultSelect.includes(1)) this.isEditQQ = true;
        }
    },
    methods: {
        /**
         * 选择修改手机号还是修改QQ号
         * @param {boolen} status 状态值
         * @return {void}
         */
        chooseEditPhoneOrQQ(string) {
            const selectNum = string === 'phone' ? 0 : 1;
            if (!selectNum) {
                this.$parent.$parent.updateSelectedItems(0, this.isEditPhone);
            } else {
                this.$parent.$parent.updateSelectedItems(1, this.isEditQQ);
            }
        },

        /**
         * 点击下一步
         * @return {void}
         */
        nextStep() {
            // 取消了那个选项，就讲哪个值值为空
            if (!this.isEditQQ) {
                this.$parent.$parent.getNewQQFrom('');
            }
            if (!this.isEditPhone) {
                this.$parent.$parent.getNewPhoneFrom('');
            }
            // 临时变量，qq和手机是否都修改好了
            let isQQFinish = false;
            let isPhoneFinish = false;
            // 如果点击了修改QQ，并且老的qq号还存在，需要验证一下新的管理员QQ号是否存在了
            if (this.isEditQQ && this.contact.admin_qq) {
                // 如果新的管理员QQ还没有添加，需要提示用户
                if (!this.myNewQQ) {
                    this.$parent.$parent.getNewQQFrom('');
                    this.$message.error(this.$t('请添加新管理员QQ'));
                    return;
                }

                // 新QQ号验证成功
                this.$parent.$parent.getNewQQFrom(this.newQQ);
                isQQFinish = true;
            }
            // 如果点击了修改电话，并且老的电话号还在，新的手机号也存在了，新的手机号还是合法的，验证码也存在了，发请求去验证验证码是否正确
            if (this.isEditPhone && this.contact.mobile && this.isPhoneTrue && this.checkNumber && this.newPhone) {
                this.$ajax.post('/mng/account/contacts/checkContactVerifyCode', {
                    phone: this.newPhone,
                    code: this.checkNumber,
                }).then((res) => {
                    if (res.code == 0) {
                        isPhoneFinish = true;
                        this.$parent.$parent.getNewPhoneFrom(this.newPhone);
                        this.$message.success(this.$t('验证码验证成功'));
                        // 清空验证码
                        this.checkNumber = '';
                        // 跳转到文件上传页
                        this.gotoUploadPage(this.isEditQQ, isQQFinish, this.isEditPhone, isPhoneFinish);
                    } else if (res.message) {
                        this.$parent.$parent.getNewPhoneFrom('');
                        this.$message.error(res.message);
                        return;
                    }
                });
            } else {
                this.gotoUploadPage(this.isEditQQ, isQQFinish, this.isEditPhone, isPhoneFinish);
            }
        },

        /**
         * 跳转到上传文件页
         * @return {void}
         */
        gotoUploadPage(isEditQQ, isQQFinish, isEditPhone, isPhoneFinish) {
            console.log('跳转到上传文件页');
            if ((isEditQQ && isQQFinish) || (isEditPhone && isPhoneFinish)) {
                this.$parent.$parent.clickNextStep();
            }
        },

        /**
         * 获取验证码 普通版本
         * @return {void}
         */
        getYzm() {
            if (!(/^1[3456789]\d{9}$/.test(this.newPhone))) {
                this.errorPhoneTips = this.$t('请输入正确的手机号');
                this.$message.error(this.$t('手机号不合法'));
                this.isPhoneTrue = false;
                return;
            }
            if (this.contact.mobile == this.newPhone) {
                this.errorPhoneTips = this.$t('请填写新联系手机');
                this.$message.error(this.$t('请填写新联系手机'));
                this.isPhoneTrue = false;
                return;
            }

            this.isPhoneTrue = true;
            this.$ajax.post('/mng/account/contacts/sendContactVerifySMS', { phone: this.newPhone }).then((res) => {
                if (res.code == 0) {
                    this.$message.success(this.$t('短信已发送，请注意查收'));
                    const runningSeconds = COUNT_DOWN_SECONDS;
                    this.isGetingVCode = true;
                    setTimeout(() => {
                        this.countDown(runningSeconds);
                    }, 1000);
                } else {
                    this.$message.error(this.$t('获取验证码失败'));
                }
            });
        },

        /**
         * 验证码倒计时
         * @param {number} runningSeconds 倒计时初始值
         * @return {void}
         */
        countDown(runningSeconds) {
            if (runningSeconds > 0) {
                this.isGetingVCode = true;
                this.VcodeText = this.$t('请稍候({n})', { n: runningSeconds });
                runningSeconds--;
                setTimeout(() => {
                    this.countDown(runningSeconds);
                }, 1000);
            } else {
                this.isGetingVCode = false;
                this.VcodeText = this.$t('重新发送');
            }
        },

        /**
         * 检查新手机号是否合格
         * @param {number} runningSeconds 倒计时初始值
         * @return {void}
         */
        checkNum() {
            if (!(/^1[3456789]\d{9}$/.test(this.newPhone))) {
                this.errorPhoneTips = this.$t('请输入正确的手机号');
                this.$message.error(this.$t('手机号不合法'));
                this.isPhoneTrue = false;
                return false;
            }
            if (this.contact.mobile == this.newPhone) {
                this.errorPhoneTips = this.$t('请填写新管理员手机');
                this.$message.error(this.$t('请填写新管理员手机'));
                this.isPhoneTrue = false;
                return false;
            }
            if (this.contact.mobile == this.newPhone) {
                this.$message.error(this.$t('请填写新管理员手机'));
                return false;
            }

            return true;
        },

        /**
         * 添加新管理员QQ
         * @return {void}
         */
        addNewAdminQQ() {
            this.isEditQQ = true;
            this.$parent.$parent.getShowQQLogin();
            setTimeout(() => {
                this.$parent.$parent.clickAddNewAdminQQ(true);
            }, 0);
        },

        /**
         * 删除新管理员QQ为了重新输入新QQ--删除弹框的确认事件
         * @return {void}
         */
        deleteNewAdminQQ() {
            this.$parent.$parent.getNewQQFrom('');
        },

        /**
         * 删除新管理员QQ为了重新输入新QQ—-删除弹框的取消事件
         * 使用vhtml组件，不定一个函数好像是有问题
         * @return {void}
         */
        handleVisibleChange() {
            return;
        },

        /**
         * 记录一下当前输入的手机号
         * 由于切换到QQ登录之后，再到编辑界面，不知道为什么会导致当前组件的重新加载一次，导致数据丢失了，所以在上一层，也就是父组件app中存储一下，再灌入到本组件中
         * @return {void}
         */
        storagePhoneNum(value) {
            if (!value) return;
        },
        cancel() {
            this.$parent.$parent.cancel();
        },
    },
};
</script>

<style lang="less" scoped>
.edit-contact {
    width: 472px;

    &-inner {
        margin-top: 12px;
        text-align: left;

        /deep/ .v-description-item--horizontal {
            align-items: center;
        }

        /deep/ .v-description-item--value {
            height: 32px;
            line-height: 32px;
            padding: 0;
        }
    }

    &-item {
        &-yzmCode {
            display: flex;
            align-items: flex-end;
        }
    }

    &-bottom {
        width: 100%;
        height: 72px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        &-button {
            margin-top: 30px;
        }
    }
}

.old-contact-item {
    padding-top: 23px;
    font-size: 14px;
    line-height: 19.6px;
    color: #A8ABB3;

    &-number {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #1E2330;

        &-newQQ {
            padding-right: 6px;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 22px;
            color: #1E2330;
        }

    }
}

.new-contact-item {
    padding-top: 22px;
    font-size: 14px;
    line-height: 19.6px;
    color: #A8ABB3;
    display: flex;
    justify-content: space-between;
    max-width: 285px;

    &-select {
        width: 100%;
    }
}

.phone-prefix {
    font-size: 14px;
    color: #A8ABB3;
    letter-spacing: 0;
    text-align: right;
}

.geryzm-button {
    padding: 0;
    width: 102px;
    height: 32px;
    margin-left: 7px;
    font-size: 14px;
    text-align: center;
    vertical-align: bottom;
}

.hight-light-for-new-phone {
    color: #0067ED;
}

.edit-contact-item-box-for-opacity {
    opacity: 0.38;
}

.hiddenbychange {
    display: none;
}

.isError {
    color: #FF4222;
}
</style>

